import { default as _4043DAwsnwioOMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue?macro=true";
import { default as CoinsListMSazDlUwY9Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue?macro=true";
import { default as EmptyVouhvbj28DMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue?macro=true";
import { default as LayouttlXs6O9xhRMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue?macro=true";
import { default as indexADR0yCnVL6Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue?macro=true";
import { default as rulepLS6Xa3QqHMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue?macro=true";
import { default as how_45we_45startedPvWiUcsq8tMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue?macro=true";
import { default as indexGbeB8bwNX6Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue?macro=true";
import { default as why_45book_45with_45usAgNwbxc74NMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue?macro=true";
import { default as business_45licenseyZIrAgFjbBMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue?macro=true";
import { default as callserviceKfeD2buFrUMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue?macro=true";
import { default as customerPhoneAdaptercNzdKbSH8NMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts?macro=true";
import { default as indexeWuxDiCcEBMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue?macro=true";
import { default as other_45regionsGoguuLaer8Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue?macro=true";
import { default as email_45ustMtk6l6L6SMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue?macro=true";
import { default as _91id_93fhVOitTyXIMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue?macro=true";
import { default as faqKDyX0h0pPvMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue?macro=true";
import { default as feedbackFKnrzmANqcMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue?macro=true";
import { default as privacy_45policyrwLyiJDJqcMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue?macro=true";
import { default as submit_45questionKTtPOOo3x5Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue?macro=true";
import { default as subscriptionrwI8nGjsvcMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue?macro=true";
import { default as terms_45and_45conditionshcagWPXQDiMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue?macro=true";
import { default as unsubscribenNqD4ArJ4pMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue?macro=true";
import { default as coupon_46trackv6Nh9cmCRlMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts?macro=true";
import { default as indexMpfX9IW4cCMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue?macro=true";
import { default as indexF92gaFeNJsMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue?macro=true";
import { default as fillWGzahpq4A7Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue?macro=true";
import { default as listltYA9uKCEPMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue?macro=true";
import { default as indexpbzLLMHmSUMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue?macro=true";
import { default as main_45flightsO9vOb29IQNMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue?macro=true";
import { default as main_45hotelsW9WdciGvZKMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue?macro=true";
import { default as main_45trainsFkCaeOg73CMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue?macro=true";
import { default as changepassword0BYsCzb7iSMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue?macro=true";
import { default as collectionsW8FGx9OcHkMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue?macro=true";
import { default as couponYI2UCs4w7WMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue?macro=true";
import { default as deleteaccountyh8qiv4QpRMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue?macro=true";
import { default as order7vSpqmTcXrMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue?macro=true";
import { default as trRowDkskcR7FaDMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue?macro=true";
import { default as editcYEH78TcjNMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue?macro=true";
import { default as listFl4T873wT3Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue?macro=true";
import { default as profilelkmZyvVPNUMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue?macro=true";
import { default as TravelerCardmXTmJBCl4jMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue?macro=true";
import { default as TravelerFormvU6HnvGr6IMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue?macro=true";
import { default as typeTsbyAxcM13Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts?macro=true";
import { default as indexS0kzxrFah9Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue?macro=true";
import { default as search8yWnc2zbDEMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue?macro=true";
import { default as defaultAreaCodeCMtFnmHXh4Meta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts?macro=true";
import { default as forgotpassworddIeZiqa76vMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue?macro=true";
import { default as signinlSMegm6ThTMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue?macro=true";
import { default as signupoefkNKDjZjMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue?macro=true";
import { default as trackerCxR2RaIYMfMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts?macro=true";
import { default as index18RMcZIEyOMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue?macro=true";
import { default as piniapfktKYURJuMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue?macro=true";
import { default as _91nameId_93RiJ3MUtJLBMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue?macro=true";
import { default as indextxzPft6s6CMeta } from "/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue?macro=true";
export default [
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-xx___default",
    path: _4043DAwsnwioOMeta?.path ?? "/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-xx",
    path: _4043DAwsnwioOMeta?.path ?? "/en-xx/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___zh-hk",
    path: _4043DAwsnwioOMeta?.path ?? "/zh-hk/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___zh-tw",
    path: _4043DAwsnwioOMeta?.path ?? "/zh-tw/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-us",
    path: _4043DAwsnwioOMeta?.path ?? "/en-us/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-gb",
    path: _4043DAwsnwioOMeta?.path ?? "/en-gb/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-hk",
    path: _4043DAwsnwioOMeta?.path ?? "/en-hk/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-id",
    path: _4043DAwsnwioOMeta?.path ?? "/en-id/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-in",
    path: _4043DAwsnwioOMeta?.path ?? "/en-in/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___de-de",
    path: _4043DAwsnwioOMeta?.path ?? "/de-de/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-sg",
    path: _4043DAwsnwioOMeta?.path ?? "/en-sg/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-au",
    path: _4043DAwsnwioOMeta?.path ?? "/en-au/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-my",
    path: _4043DAwsnwioOMeta?.path ?? "/en-my/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-ph",
    path: _4043DAwsnwioOMeta?.path ?? "/en-ph/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-nz",
    path: _4043DAwsnwioOMeta?.path ?? "/en-nz/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___en-ca",
    path: _4043DAwsnwioOMeta?.path ?? "/en-ca/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___ja-jp",
    path: _4043DAwsnwioOMeta?.path ?? "/ja-jp/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _4043DAwsnwioOMeta?.name ?? "404___ko-kr",
    path: _4043DAwsnwioOMeta?.path ?? "/ko-kr/404",
    meta: _4043DAwsnwioOMeta || {},
    alias: _4043DAwsnwioOMeta?.alias || [],
    redirect: _4043DAwsnwioOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/404.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-xx___default",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-xx",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-xx/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___zh-hk",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/zh-hk/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___zh-tw",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/zh-tw/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-us",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-us/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-gb",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-gb/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-hk",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-hk/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-id",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-id/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-in",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-in/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___de-de",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/de-de/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-sg",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-sg/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-au",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-au/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-my",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-my/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-ph",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-ph/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-nz",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-nz/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___en-ca",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/en-ca/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___ja-jp",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/ja-jp/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: CoinsListMSazDlUwY9Meta?.name ?? "coins-components-coinsList-CoinsList___ko-kr",
    path: CoinsListMSazDlUwY9Meta?.path ?? "/ko-kr/coins/components/coinsList/CoinsList",
    meta: CoinsListMSazDlUwY9Meta || {},
    alias: CoinsListMSazDlUwY9Meta?.alias || [],
    redirect: CoinsListMSazDlUwY9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/coinsList/CoinsList.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-xx___default",
    path: EmptyVouhvbj28DMeta?.path ?? "/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-xx",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-xx/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___zh-hk",
    path: EmptyVouhvbj28DMeta?.path ?? "/zh-hk/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___zh-tw",
    path: EmptyVouhvbj28DMeta?.path ?? "/zh-tw/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-us",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-us/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-gb",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-gb/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-hk",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-hk/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-id",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-id/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-in",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-in/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___de-de",
    path: EmptyVouhvbj28DMeta?.path ?? "/de-de/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-sg",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-sg/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-au",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-au/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-my",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-my/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-ph",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-ph/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-nz",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-nz/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___en-ca",
    path: EmptyVouhvbj28DMeta?.path ?? "/en-ca/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___ja-jp",
    path: EmptyVouhvbj28DMeta?.path ?? "/ja-jp/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: EmptyVouhvbj28DMeta?.name ?? "coins-components-empty-Empty___ko-kr",
    path: EmptyVouhvbj28DMeta?.path ?? "/ko-kr/coins/components/empty/Empty",
    meta: EmptyVouhvbj28DMeta || {},
    alias: EmptyVouhvbj28DMeta?.alias || [],
    redirect: EmptyVouhvbj28DMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/empty/Empty.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-xx___default",
    path: LayouttlXs6O9xhRMeta?.path ?? "/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-xx",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-xx/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___zh-hk",
    path: LayouttlXs6O9xhRMeta?.path ?? "/zh-hk/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___zh-tw",
    path: LayouttlXs6O9xhRMeta?.path ?? "/zh-tw/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-us",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-us/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-gb",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-gb/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-hk",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-hk/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-id",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-id/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-in",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-in/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___de-de",
    path: LayouttlXs6O9xhRMeta?.path ?? "/de-de/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-sg",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-sg/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-au",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-au/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-my",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-my/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-ph",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-ph/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-nz",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-nz/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___en-ca",
    path: LayouttlXs6O9xhRMeta?.path ?? "/en-ca/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___ja-jp",
    path: LayouttlXs6O9xhRMeta?.path ?? "/ja-jp/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: LayouttlXs6O9xhRMeta?.name ?? "coins-components-layout-Layout___ko-kr",
    path: LayouttlXs6O9xhRMeta?.path ?? "/ko-kr/coins/components/layout/Layout",
    meta: LayouttlXs6O9xhRMeta || {},
    alias: LayouttlXs6O9xhRMeta?.alias || [],
    redirect: LayouttlXs6O9xhRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/components/layout/Layout.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-xx___default",
    path: indexADR0yCnVL6Meta?.path ?? "/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-xx",
    path: indexADR0yCnVL6Meta?.path ?? "/en-xx/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___zh-hk",
    path: indexADR0yCnVL6Meta?.path ?? "/zh-hk/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___zh-tw",
    path: indexADR0yCnVL6Meta?.path ?? "/zh-tw/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-us",
    path: indexADR0yCnVL6Meta?.path ?? "/en-us/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-gb",
    path: indexADR0yCnVL6Meta?.path ?? "/en-gb/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-hk",
    path: indexADR0yCnVL6Meta?.path ?? "/en-hk/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-id",
    path: indexADR0yCnVL6Meta?.path ?? "/en-id/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-in",
    path: indexADR0yCnVL6Meta?.path ?? "/en-in/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___de-de",
    path: indexADR0yCnVL6Meta?.path ?? "/de-de/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-sg",
    path: indexADR0yCnVL6Meta?.path ?? "/en-sg/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-au",
    path: indexADR0yCnVL6Meta?.path ?? "/en-au/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-my",
    path: indexADR0yCnVL6Meta?.path ?? "/en-my/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-ph",
    path: indexADR0yCnVL6Meta?.path ?? "/en-ph/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-nz",
    path: indexADR0yCnVL6Meta?.path ?? "/en-nz/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___en-ca",
    path: indexADR0yCnVL6Meta?.path ?? "/en-ca/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___ja-jp",
    path: indexADR0yCnVL6Meta?.path ?? "/ja-jp/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: indexADR0yCnVL6Meta?.name ?? "coins___ko-kr",
    path: indexADR0yCnVL6Meta?.path ?? "/ko-kr/coins",
    meta: indexADR0yCnVL6Meta || {},
    alias: indexADR0yCnVL6Meta?.alias || [],
    redirect: indexADR0yCnVL6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/index.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-xx___default",
    path: rulepLS6Xa3QqHMeta?.path ?? "/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-xx",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-xx/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___zh-hk",
    path: rulepLS6Xa3QqHMeta?.path ?? "/zh-hk/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___zh-tw",
    path: rulepLS6Xa3QqHMeta?.path ?? "/zh-tw/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-us",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-us/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-gb",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-gb/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-hk",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-hk/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-id",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-id/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-in",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-in/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___de-de",
    path: rulepLS6Xa3QqHMeta?.path ?? "/de-de/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-sg",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-sg/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-au",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-au/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-my",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-my/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-ph",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-ph/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-nz",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-nz/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___en-ca",
    path: rulepLS6Xa3QqHMeta?.path ?? "/en-ca/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___ja-jp",
    path: rulepLS6Xa3QqHMeta?.path ?? "/ja-jp/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: rulepLS6Xa3QqHMeta?.name ?? "coins-rule___ko-kr",
    path: rulepLS6Xa3QqHMeta?.path ?? "/ko-kr/coins/rule",
    meta: rulepLS6Xa3QqHMeta || {},
    alias: rulepLS6Xa3QqHMeta?.alias || [],
    redirect: rulepLS6Xa3QqHMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coins/rule.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-xx___default",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-xx",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-xx/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___zh-hk",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/zh-hk/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___zh-tw",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/zh-tw/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-us",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-us/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-gb",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-gb/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-hk",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-hk/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-id",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-id/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-in",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-in/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___de-de",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/de-de/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-sg",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-sg/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-au",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-au/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-my",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-my/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-ph",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-ph/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-nz",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-nz/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___en-ca",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/en-ca/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___ja-jp",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/ja-jp/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: how_45we_45startedPvWiUcsq8tMeta?.name ?? "common-about-us-how-we-started___ko-kr",
    path: how_45we_45startedPvWiUcsq8tMeta?.path ?? "/ko-kr/common/about-us/how-we-started",
    meta: how_45we_45startedPvWiUcsq8tMeta || {},
    alias: how_45we_45startedPvWiUcsq8tMeta?.alias || [],
    redirect: how_45we_45startedPvWiUcsq8tMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/how-we-started.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-xx___default",
    path: indexGbeB8bwNX6Meta?.path ?? "/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-xx",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-xx/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___zh-hk",
    path: indexGbeB8bwNX6Meta?.path ?? "/zh-hk/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___zh-tw",
    path: indexGbeB8bwNX6Meta?.path ?? "/zh-tw/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-us",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-us/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-gb",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-gb/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-hk",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-hk/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-id",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-id/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-in",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-in/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___de-de",
    path: indexGbeB8bwNX6Meta?.path ?? "/de-de/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-sg",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-sg/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-au",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-au/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-my",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-my/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-ph",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-ph/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-nz",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-nz/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___en-ca",
    path: indexGbeB8bwNX6Meta?.path ?? "/en-ca/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___ja-jp",
    path: indexGbeB8bwNX6Meta?.path ?? "/ja-jp/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexGbeB8bwNX6Meta?.name ?? "common-about-us___ko-kr",
    path: indexGbeB8bwNX6Meta?.path ?? "/ko-kr/common/about-us",
    meta: indexGbeB8bwNX6Meta || {},
    alias: indexGbeB8bwNX6Meta?.alias || [],
    redirect: indexGbeB8bwNX6Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-xx___default",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-xx",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-xx/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___zh-hk",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/zh-hk/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___zh-tw",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/zh-tw/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-us",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-us/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-gb",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-gb/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-hk",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-hk/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-id",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-id/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-in",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-in/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___de-de",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/de-de/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-sg",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-sg/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-au",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-au/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-my",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-my/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-ph",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-ph/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-nz",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-nz/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___en-ca",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/en-ca/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___ja-jp",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/ja-jp/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: why_45book_45with_45usAgNwbxc74NMeta?.name ?? "common-about-us-why-book-with-us___ko-kr",
    path: why_45book_45with_45usAgNwbxc74NMeta?.path ?? "/ko-kr/common/about-us/why-book-with-us",
    meta: why_45book_45with_45usAgNwbxc74NMeta || {},
    alias: why_45book_45with_45usAgNwbxc74NMeta?.alias || [],
    redirect: why_45book_45with_45usAgNwbxc74NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/about-us/why-book-with-us.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-xx___default",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-xx",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-xx/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___zh-hk",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/zh-hk/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___zh-tw",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/zh-tw/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-us",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-us/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-gb",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-gb/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-hk",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-hk/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-id",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-id/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-in",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-in/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___de-de",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/de-de/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-sg",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-sg/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-au",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-au/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-my",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-my/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-ph",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-ph/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-nz",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-nz/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___en-ca",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/en-ca/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___ja-jp",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/ja-jp/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: business_45licenseyZIrAgFjbBMeta?.name ?? "common-business-license___ko-kr",
    path: business_45licenseyZIrAgFjbBMeta?.path ?? "/ko-kr/common/business-license",
    meta: business_45licenseyZIrAgFjbBMeta || {},
    alias: business_45licenseyZIrAgFjbBMeta?.alias || [],
    redirect: business_45licenseyZIrAgFjbBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/business-license.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-xx___default",
    path: callserviceKfeD2buFrUMeta?.path ?? "/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-xx",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-xx/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___zh-hk",
    path: callserviceKfeD2buFrUMeta?.path ?? "/zh-hk/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___zh-tw",
    path: callserviceKfeD2buFrUMeta?.path ?? "/zh-tw/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-us",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-us/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-gb",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-gb/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-hk",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-hk/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-id",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-id/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-in",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-in/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___de-de",
    path: callserviceKfeD2buFrUMeta?.path ?? "/de-de/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-sg",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-sg/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-au",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-au/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-my",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-my/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-ph",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-ph/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-nz",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-nz/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___en-ca",
    path: callserviceKfeD2buFrUMeta?.path ?? "/en-ca/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___ja-jp",
    path: callserviceKfeD2buFrUMeta?.path ?? "/ja-jp/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: callserviceKfeD2buFrUMeta?.name ?? "common-customer-callservice___ko-kr",
    path: callserviceKfeD2buFrUMeta?.path ?? "/ko-kr/common/customer/callservice",
    meta: callserviceKfeD2buFrUMeta || {},
    alias: callserviceKfeD2buFrUMeta?.alias || [],
    redirect: callserviceKfeD2buFrUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/callservice.vue").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-xx___default",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-xx",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-xx/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___zh-hk",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/zh-hk/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___zh-tw",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/zh-tw/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-us",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-us/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-gb",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-gb/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-hk",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-hk/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-id",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-id/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-in",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-in/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___de-de",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/de-de/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-sg",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-sg/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-au",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-au/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-my",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-my/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-ph",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-ph/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-nz",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-nz/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___en-ca",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/en-ca/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___ja-jp",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/ja-jp/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: customerPhoneAdaptercNzdKbSH8NMeta?.name ?? "common-customer-customerPhoneAdapter___ko-kr",
    path: customerPhoneAdaptercNzdKbSH8NMeta?.path ?? "/ko-kr/common/customer/customerPhoneAdapter",
    meta: customerPhoneAdaptercNzdKbSH8NMeta || {},
    alias: customerPhoneAdaptercNzdKbSH8NMeta?.alias || [],
    redirect: customerPhoneAdaptercNzdKbSH8NMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/customerPhoneAdapter.ts").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-xx___default",
    path: indexeWuxDiCcEBMeta?.path ?? "/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-xx",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-xx/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___zh-hk",
    path: indexeWuxDiCcEBMeta?.path ?? "/zh-hk/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___zh-tw",
    path: indexeWuxDiCcEBMeta?.path ?? "/zh-tw/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-us",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-us/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-gb",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-gb/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-hk",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-hk/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-id",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-id/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-in",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-in/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___de-de",
    path: indexeWuxDiCcEBMeta?.path ?? "/de-de/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-sg",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-sg/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-au",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-au/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-my",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-my/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-ph",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-ph/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-nz",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-nz/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___en-ca",
    path: indexeWuxDiCcEBMeta?.path ?? "/en-ca/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___ja-jp",
    path: indexeWuxDiCcEBMeta?.path ?? "/ja-jp/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: indexeWuxDiCcEBMeta?.name ?? "common-customer___ko-kr",
    path: indexeWuxDiCcEBMeta?.path ?? "/ko-kr/common/customer",
    meta: indexeWuxDiCcEBMeta || {},
    alias: indexeWuxDiCcEBMeta?.alias || [],
    redirect: indexeWuxDiCcEBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/index.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-xx___default",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-xx",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-xx/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___zh-hk",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/zh-hk/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___zh-tw",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/zh-tw/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-us",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-us/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-gb",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-gb/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-hk",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-hk/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-id",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-id/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-in",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-in/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___de-de",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/de-de/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-sg",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-sg/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-au",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-au/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-my",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-my/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-ph",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-ph/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-nz",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-nz/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___en-ca",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/en-ca/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___ja-jp",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/ja-jp/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: other_45regionsGoguuLaer8Meta?.name ?? "common-customer-other-regions___ko-kr",
    path: other_45regionsGoguuLaer8Meta?.path ?? "/ko-kr/common/customer/other-regions",
    meta: other_45regionsGoguuLaer8Meta || {},
    alias: other_45regionsGoguuLaer8Meta?.alias || [],
    redirect: other_45regionsGoguuLaer8Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/customer/other-regions.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-xx___default",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-xx",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-xx/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___zh-hk",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/zh-hk/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___zh-tw",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/zh-tw/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-us",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-us/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-gb",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-gb/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-hk",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-hk/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-id",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-id/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-in",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-in/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___de-de",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/de-de/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-sg",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-sg/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-au",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-au/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-my",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-my/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-ph",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-ph/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-nz",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-nz/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___en-ca",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/en-ca/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___ja-jp",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/ja-jp/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: email_45ustMtk6l6L6SMeta?.name ?? "common-email-us___ko-kr",
    path: email_45ustMtk6l6L6SMeta?.path ?? "/ko-kr/common/email-us",
    meta: email_45ustMtk6l6L6SMeta || {},
    alias: email_45ustMtk6l6L6SMeta?.alias || [],
    redirect: email_45ustMtk6l6L6SMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/email-us.vue").then(m => m.default || m)
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-xx___default",
    path: faqKDyX0h0pPvMeta?.path ?? "/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-xx___default",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-xx",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-xx/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-xx",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___zh-hk",
    path: faqKDyX0h0pPvMeta?.path ?? "/zh-hk/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___zh-hk",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___zh-tw",
    path: faqKDyX0h0pPvMeta?.path ?? "/zh-tw/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___zh-tw",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-us",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-us/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-us",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-gb",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-gb/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-gb",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-hk",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-hk/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-hk",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-id",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-id/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-id",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-in",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-in/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-in",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___de-de",
    path: faqKDyX0h0pPvMeta?.path ?? "/de-de/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___de-de",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-sg",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-sg/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-sg",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-au",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-au/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-au",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-my",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-my/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-my",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-ph",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-ph/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-ph",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-nz",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-nz/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-nz",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___en-ca",
    path: faqKDyX0h0pPvMeta?.path ?? "/en-ca/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___en-ca",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___ja-jp",
    path: faqKDyX0h0pPvMeta?.path ?? "/ja-jp/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___ja-jp",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: faqKDyX0h0pPvMeta?.name ?? "common-faq___ko-kr",
    path: faqKDyX0h0pPvMeta?.path ?? "/ko-kr/common/faq",
    meta: faqKDyX0h0pPvMeta || {},
    alias: faqKDyX0h0pPvMeta?.alias || [],
    redirect: faqKDyX0h0pPvMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93fhVOitTyXIMeta?.name ?? "common-faq-id___ko-kr",
    path: _91id_93fhVOitTyXIMeta?.path ?? ":id()",
    meta: _91id_93fhVOitTyXIMeta || {},
    alias: _91id_93fhVOitTyXIMeta?.alias || [],
    redirect: _91id_93fhVOitTyXIMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/faq/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-xx___default",
    path: feedbackFKnrzmANqcMeta?.path ?? "/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-xx",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-xx/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___zh-hk",
    path: feedbackFKnrzmANqcMeta?.path ?? "/zh-hk/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___zh-tw",
    path: feedbackFKnrzmANqcMeta?.path ?? "/zh-tw/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-us",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-us/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-gb",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-gb/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-hk",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-hk/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-id",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-id/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-in",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-in/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___de-de",
    path: feedbackFKnrzmANqcMeta?.path ?? "/de-de/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-sg",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-sg/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-au",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-au/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-my",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-my/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-ph",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-ph/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-nz",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-nz/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___en-ca",
    path: feedbackFKnrzmANqcMeta?.path ?? "/en-ca/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___ja-jp",
    path: feedbackFKnrzmANqcMeta?.path ?? "/ja-jp/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackFKnrzmANqcMeta?.name ?? "common-feedback___ko-kr",
    path: feedbackFKnrzmANqcMeta?.path ?? "/ko-kr/common/feedback",
    meta: feedbackFKnrzmANqcMeta || {},
    alias: feedbackFKnrzmANqcMeta?.alias || [],
    redirect: feedbackFKnrzmANqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/feedback.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-xx___default",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-xx",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-xx/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___zh-hk",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/zh-hk/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___zh-tw",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/zh-tw/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-us",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-us/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-gb",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-gb/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-hk",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-hk/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-id",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-id/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-in",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-in/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___de-de",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/de-de/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-sg",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-sg/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-au",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-au/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-my",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-my/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-ph",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-ph/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-nz",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-nz/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___en-ca",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/en-ca/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___ja-jp",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/ja-jp/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyrwLyiJDJqcMeta?.name ?? "common-privacy-policy___ko-kr",
    path: privacy_45policyrwLyiJDJqcMeta?.path ?? "/ko-kr/common/privacy-policy",
    meta: privacy_45policyrwLyiJDJqcMeta || {},
    alias: privacy_45policyrwLyiJDJqcMeta?.alias || [],
    redirect: privacy_45policyrwLyiJDJqcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-xx___default",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-xx",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-xx/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___zh-hk",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/zh-hk/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___zh-tw",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/zh-tw/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-us",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-us/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-gb",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-gb/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-hk",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-hk/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-id",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-id/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-in",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-in/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___de-de",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/de-de/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-sg",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-sg/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-au",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-au/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-my",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-my/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-ph",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-ph/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-nz",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-nz/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___en-ca",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/en-ca/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___ja-jp",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/ja-jp/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: submit_45questionKTtPOOo3x5Meta?.name ?? "common-submit-question___ko-kr",
    path: submit_45questionKTtPOOo3x5Meta?.path ?? "/ko-kr/common/submit-question",
    meta: submit_45questionKTtPOOo3x5Meta || {},
    alias: submit_45questionKTtPOOo3x5Meta?.alias || [],
    redirect: submit_45questionKTtPOOo3x5Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/submit-question.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-xx___default",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-xx",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-xx/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___zh-hk",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/zh-hk/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___zh-tw",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/zh-tw/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-us",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-us/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-gb",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-gb/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-hk",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-hk/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-id",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-id/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-in",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-in/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___de-de",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/de-de/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-sg",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-sg/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-au",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-au/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-my",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-my/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-ph",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-ph/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-nz",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-nz/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___en-ca",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/en-ca/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___ja-jp",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/ja-jp/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: subscriptionrwI8nGjsvcMeta?.name ?? "common-subscription___ko-kr",
    path: subscriptionrwI8nGjsvcMeta?.path ?? "/ko-kr/common/subscription",
    meta: subscriptionrwI8nGjsvcMeta || {},
    alias: subscriptionrwI8nGjsvcMeta?.alias || [],
    redirect: subscriptionrwI8nGjsvcMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/subscription.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-xx___default",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-xx",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-xx/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___zh-hk",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/zh-hk/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___zh-tw",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/zh-tw/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-us",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-us/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-gb",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-gb/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-hk",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-hk/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-id",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-id/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-in",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-in/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___de-de",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/de-de/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-sg",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-sg/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-au",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-au/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-my",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-my/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-ph",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-ph/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-nz",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-nz/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___en-ca",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/en-ca/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___ja-jp",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/ja-jp/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionshcagWPXQDiMeta?.name ?? "common-terms-and-conditions___ko-kr",
    path: terms_45and_45conditionshcagWPXQDiMeta?.path ?? "/ko-kr/common/terms-and-conditions",
    meta: terms_45and_45conditionshcagWPXQDiMeta || {},
    alias: terms_45and_45conditionshcagWPXQDiMeta?.alias || [],
    redirect: terms_45and_45conditionshcagWPXQDiMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-xx___default",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-xx",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-xx/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___zh-hk",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/zh-hk/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___zh-tw",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/zh-tw/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-us",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-us/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-gb",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-gb/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-hk",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-hk/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-id",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-id/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-in",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-in/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___de-de",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/de-de/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-sg",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-sg/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-au",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-au/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-my",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-my/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-ph",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-ph/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-nz",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-nz/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___en-ca",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/en-ca/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___ja-jp",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/ja-jp/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: unsubscribenNqD4ArJ4pMeta?.name ?? "common-unsubscribe___ko-kr",
    path: unsubscribenNqD4ArJ4pMeta?.path ?? "/ko-kr/common/unsubscribe",
    meta: unsubscribenNqD4ArJ4pMeta || {},
    alias: unsubscribenNqD4ArJ4pMeta?.alias || [],
    redirect: unsubscribenNqD4ArJ4pMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/common/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-xx___default",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-xx",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-xx/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___zh-hk",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/zh-hk/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___zh-tw",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/zh-tw/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-us",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-us/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-gb",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-gb/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-hk",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-hk/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-id",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-id/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-in",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-in/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___de-de",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/de-de/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-sg",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-sg/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-au",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-au/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-my",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-my/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-ph",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-ph/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-nz",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-nz/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___en-ca",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/en-ca/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___ja-jp",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/ja-jp/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: coupon_46trackv6Nh9cmCRlMeta?.name ?? "coupon-coupon.track___ko-kr",
    path: coupon_46trackv6Nh9cmCRlMeta?.path ?? "/ko-kr/coupon/coupon.track",
    meta: coupon_46trackv6Nh9cmCRlMeta || {},
    alias: coupon_46trackv6Nh9cmCRlMeta?.alias || [],
    redirect: coupon_46trackv6Nh9cmCRlMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/coupon.track.ts").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-xx___default",
    path: indexMpfX9IW4cCMeta?.path ?? "/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-xx",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-xx/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___zh-hk",
    path: indexMpfX9IW4cCMeta?.path ?? "/zh-hk/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___zh-tw",
    path: indexMpfX9IW4cCMeta?.path ?? "/zh-tw/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-us",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-us/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-gb",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-gb/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-hk",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-hk/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-id",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-id/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-in",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-in/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___de-de",
    path: indexMpfX9IW4cCMeta?.path ?? "/de-de/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-sg",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-sg/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-au",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-au/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-my",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-my/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-ph",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-ph/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-nz",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-nz/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___en-ca",
    path: indexMpfX9IW4cCMeta?.path ?? "/en-ca/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___ja-jp",
    path: indexMpfX9IW4cCMeta?.path ?? "/ja-jp/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexMpfX9IW4cCMeta?.name ?? "coupon___ko-kr",
    path: indexMpfX9IW4cCMeta?.path ?? "/ko-kr/coupon",
    meta: indexMpfX9IW4cCMeta || {},
    alias: indexMpfX9IW4cCMeta?.alias || [],
    redirect: indexMpfX9IW4cCMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/coupon/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-xx___default",
    path: indexF92gaFeNJsMeta?.path ?? "/",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-xx",
    path: indexF92gaFeNJsMeta?.path ?? "/en-xx",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___zh-hk",
    path: indexF92gaFeNJsMeta?.path ?? "/zh-hk",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___zh-tw",
    path: indexF92gaFeNJsMeta?.path ?? "/zh-tw",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-us",
    path: indexF92gaFeNJsMeta?.path ?? "/en-us",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-gb",
    path: indexF92gaFeNJsMeta?.path ?? "/en-gb",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-hk",
    path: indexF92gaFeNJsMeta?.path ?? "/en-hk",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-id",
    path: indexF92gaFeNJsMeta?.path ?? "/en-id",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-in",
    path: indexF92gaFeNJsMeta?.path ?? "/en-in",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___de-de",
    path: indexF92gaFeNJsMeta?.path ?? "/de-de",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-sg",
    path: indexF92gaFeNJsMeta?.path ?? "/en-sg",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-au",
    path: indexF92gaFeNJsMeta?.path ?? "/en-au",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-my",
    path: indexF92gaFeNJsMeta?.path ?? "/en-my",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-ph",
    path: indexF92gaFeNJsMeta?.path ?? "/en-ph",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-nz",
    path: indexF92gaFeNJsMeta?.path ?? "/en-nz",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___en-ca",
    path: indexF92gaFeNJsMeta?.path ?? "/en-ca",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___ja-jp",
    path: indexF92gaFeNJsMeta?.path ?? "/ja-jp",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexF92gaFeNJsMeta?.name ?? "index___ko-kr",
    path: indexF92gaFeNJsMeta?.path ?? "/ko-kr",
    meta: indexF92gaFeNJsMeta || {},
    alias: indexF92gaFeNJsMeta?.alias || [],
    redirect: indexF92gaFeNJsMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-xx___default",
    path: fillWGzahpq4A7Meta?.path ?? "/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-xx",
    path: fillWGzahpq4A7Meta?.path ?? "/en-xx/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___zh-hk",
    path: fillWGzahpq4A7Meta?.path ?? "/zh-hk/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___zh-tw",
    path: fillWGzahpq4A7Meta?.path ?? "/zh-tw/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-us",
    path: fillWGzahpq4A7Meta?.path ?? "/en-us/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-gb",
    path: fillWGzahpq4A7Meta?.path ?? "/en-gb/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-hk",
    path: fillWGzahpq4A7Meta?.path ?? "/en-hk/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-id",
    path: fillWGzahpq4A7Meta?.path ?? "/en-id/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-in",
    path: fillWGzahpq4A7Meta?.path ?? "/en-in/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___de-de",
    path: fillWGzahpq4A7Meta?.path ?? "/de-de/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-sg",
    path: fillWGzahpq4A7Meta?.path ?? "/en-sg/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-au",
    path: fillWGzahpq4A7Meta?.path ?? "/en-au/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-my",
    path: fillWGzahpq4A7Meta?.path ?? "/en-my/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-ph",
    path: fillWGzahpq4A7Meta?.path ?? "/en-ph/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-nz",
    path: fillWGzahpq4A7Meta?.path ?? "/en-nz/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___en-ca",
    path: fillWGzahpq4A7Meta?.path ?? "/en-ca/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___ja-jp",
    path: fillWGzahpq4A7Meta?.path ?? "/ja-jp/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: fillWGzahpq4A7Meta?.name ?? "inquiry-fill___ko-kr",
    path: fillWGzahpq4A7Meta?.path ?? "/ko-kr/inquiry/fill",
    meta: fillWGzahpq4A7Meta || {},
    alias: fillWGzahpq4A7Meta?.alias || [],
    redirect: fillWGzahpq4A7Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/fill.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-xx___default",
    path: listltYA9uKCEPMeta?.path ?? "/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-xx",
    path: listltYA9uKCEPMeta?.path ?? "/en-xx/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___zh-hk",
    path: listltYA9uKCEPMeta?.path ?? "/zh-hk/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___zh-tw",
    path: listltYA9uKCEPMeta?.path ?? "/zh-tw/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-us",
    path: listltYA9uKCEPMeta?.path ?? "/en-us/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-gb",
    path: listltYA9uKCEPMeta?.path ?? "/en-gb/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-hk",
    path: listltYA9uKCEPMeta?.path ?? "/en-hk/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-id",
    path: listltYA9uKCEPMeta?.path ?? "/en-id/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-in",
    path: listltYA9uKCEPMeta?.path ?? "/en-in/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___de-de",
    path: listltYA9uKCEPMeta?.path ?? "/de-de/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-sg",
    path: listltYA9uKCEPMeta?.path ?? "/en-sg/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-au",
    path: listltYA9uKCEPMeta?.path ?? "/en-au/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-my",
    path: listltYA9uKCEPMeta?.path ?? "/en-my/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-ph",
    path: listltYA9uKCEPMeta?.path ?? "/en-ph/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-nz",
    path: listltYA9uKCEPMeta?.path ?? "/en-nz/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___en-ca",
    path: listltYA9uKCEPMeta?.path ?? "/en-ca/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___ja-jp",
    path: listltYA9uKCEPMeta?.path ?? "/ja-jp/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: listltYA9uKCEPMeta?.name ?? "inquiry-list___ko-kr",
    path: listltYA9uKCEPMeta?.path ?? "/ko-kr/inquiry/list",
    meta: listltYA9uKCEPMeta || {},
    alias: listltYA9uKCEPMeta?.alias || [],
    redirect: listltYA9uKCEPMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/inquiry/list.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-xx___default",
    path: indexpbzLLMHmSUMeta?.path ?? "/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-xx",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-xx/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___zh-hk",
    path: indexpbzLLMHmSUMeta?.path ?? "/zh-hk/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___zh-tw",
    path: indexpbzLLMHmSUMeta?.path ?? "/zh-tw/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-us",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-us/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-gb",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-gb/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-hk",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-hk/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-id",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-id/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-in",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-in/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___de-de",
    path: indexpbzLLMHmSUMeta?.path ?? "/de-de/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-sg",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-sg/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-au",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-au/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-my",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-my/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-ph",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-ph/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-nz",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-nz/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___en-ca",
    path: indexpbzLLMHmSUMeta?.path ?? "/en-ca/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___ja-jp",
    path: indexpbzLLMHmSUMeta?.path ?? "/ja-jp/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: indexpbzLLMHmSUMeta?.name ?? "keepalive___ko-kr",
    path: indexpbzLLMHmSUMeta?.path ?? "/ko-kr/keepalive",
    meta: indexpbzLLMHmSUMeta || {},
    alias: indexpbzLLMHmSUMeta?.alias || [],
    redirect: indexpbzLLMHmSUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-xx___default",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-xx",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-xx/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___zh-hk",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/zh-hk/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___zh-tw",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/zh-tw/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-us",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-us/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-gb",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-gb/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-hk",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-hk/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-id",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-id/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-in",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-in/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___de-de",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/de-de/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-sg",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-sg/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-au",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-au/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-my",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-my/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-ph",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-ph/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-nz",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-nz/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___en-ca",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/en-ca/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___ja-jp",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/ja-jp/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45flightsO9vOb29IQNMeta?.name ?? "main-flights___ko-kr",
    path: main_45flightsO9vOb29IQNMeta?.path ?? "/ko-kr/main-flights",
    meta: main_45flightsO9vOb29IQNMeta || {},
    alias: main_45flightsO9vOb29IQNMeta?.alias || [],
    redirect: main_45flightsO9vOb29IQNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-flights.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-xx___default",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-xx",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-xx/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___zh-hk",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/zh-hk/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___zh-tw",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/zh-tw/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-us",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-us/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-gb",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-gb/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-hk",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-hk/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-id",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-id/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-in",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-in/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___de-de",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/de-de/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-sg",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-sg/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-au",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-au/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-my",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-my/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-ph",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-ph/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-nz",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-nz/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___en-ca",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/en-ca/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___ja-jp",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/ja-jp/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45hotelsW9WdciGvZKMeta?.name ?? "main-hotels___ko-kr",
    path: main_45hotelsW9WdciGvZKMeta?.path ?? "/ko-kr/main-hotels",
    meta: main_45hotelsW9WdciGvZKMeta || {},
    alias: main_45hotelsW9WdciGvZKMeta?.alias || [],
    redirect: main_45hotelsW9WdciGvZKMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-hotels.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-xx___default",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-xx",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-xx/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___zh-hk",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/zh-hk/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___zh-tw",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/zh-tw/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-us",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-us/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-gb",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-gb/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-hk",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-hk/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-id",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-id/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-in",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-in/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___de-de",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/de-de/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-sg",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-sg/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-au",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-au/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-my",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-my/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-ph",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-ph/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-nz",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-nz/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___en-ca",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/en-ca/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___ja-jp",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/ja-jp/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: main_45trainsFkCaeOg73CMeta?.name ?? "main-trains___ko-kr",
    path: main_45trainsFkCaeOg73CMeta?.path ?? "/ko-kr/main-trains",
    meta: main_45trainsFkCaeOg73CMeta || {},
    alias: main_45trainsFkCaeOg73CMeta?.alias || [],
    redirect: main_45trainsFkCaeOg73CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/main-trains.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-xx___default",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-xx",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-xx/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___zh-hk",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/zh-hk/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___zh-tw",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/zh-tw/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-us",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-us/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-gb",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-gb/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-hk",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-hk/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-id",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-id/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-in",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-in/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___de-de",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/de-de/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-sg",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-sg/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-au",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-au/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-my",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-my/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-ph",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-ph/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-nz",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-nz/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___en-ca",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/en-ca/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___ja-jp",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/ja-jp/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: changepassword0BYsCzb7iSMeta?.name ?? "member-changepassword___ko-kr",
    path: changepassword0BYsCzb7iSMeta?.path ?? "/ko-kr/member/changepassword",
    meta: changepassword0BYsCzb7iSMeta || {},
    alias: changepassword0BYsCzb7iSMeta?.alias || [],
    redirect: changepassword0BYsCzb7iSMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/changepassword.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-xx___default",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-xx",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-xx/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___zh-hk",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/zh-hk/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___zh-tw",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/zh-tw/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-us",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-us/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-gb",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-gb/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-hk",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-hk/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-id",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-id/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-in",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-in/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___de-de",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/de-de/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-sg",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-sg/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-au",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-au/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-my",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-my/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-ph",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-ph/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-nz",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-nz/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___en-ca",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/en-ca/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___ja-jp",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/ja-jp/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsW8FGx9OcHkMeta?.name ?? "member-collections___ko-kr",
    path: collectionsW8FGx9OcHkMeta?.path ?? "/ko-kr/member/collections",
    meta: collectionsW8FGx9OcHkMeta || {},
    alias: collectionsW8FGx9OcHkMeta?.alias || [],
    redirect: collectionsW8FGx9OcHkMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/collections.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-xx___default",
    path: couponYI2UCs4w7WMeta?.path ?? "/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-xx",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-xx/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___zh-hk",
    path: couponYI2UCs4w7WMeta?.path ?? "/zh-hk/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___zh-tw",
    path: couponYI2UCs4w7WMeta?.path ?? "/zh-tw/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-us",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-us/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-gb",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-gb/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-hk",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-hk/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-id",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-id/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-in",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-in/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___de-de",
    path: couponYI2UCs4w7WMeta?.path ?? "/de-de/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-sg",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-sg/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-au",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-au/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-my",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-my/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-ph",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-ph/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-nz",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-nz/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___en-ca",
    path: couponYI2UCs4w7WMeta?.path ?? "/en-ca/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___ja-jp",
    path: couponYI2UCs4w7WMeta?.path ?? "/ja-jp/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: couponYI2UCs4w7WMeta?.name ?? "member-coupon___ko-kr",
    path: couponYI2UCs4w7WMeta?.path ?? "/ko-kr/member/coupon",
    meta: couponYI2UCs4w7WMeta || {},
    alias: couponYI2UCs4w7WMeta?.alias || [],
    redirect: couponYI2UCs4w7WMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/coupon.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-xx___default",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-xx",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-xx/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___zh-hk",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/zh-hk/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___zh-tw",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/zh-tw/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-us",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-us/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-gb",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-gb/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-hk",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-hk/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-id",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-id/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-in",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-in/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___de-de",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/de-de/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-sg",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-sg/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-au",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-au/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-my",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-my/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-ph",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-ph/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-nz",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-nz/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___en-ca",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/en-ca/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___ja-jp",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/ja-jp/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountyh8qiv4QpRMeta?.name ?? "member-deleteaccount___ko-kr",
    path: deleteaccountyh8qiv4QpRMeta?.path ?? "/ko-kr/member/deleteaccount",
    meta: deleteaccountyh8qiv4QpRMeta || {},
    alias: deleteaccountyh8qiv4QpRMeta?.alias || [],
    redirect: deleteaccountyh8qiv4QpRMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-xx___default",
    path: order7vSpqmTcXrMeta?.path ?? "/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-xx",
    path: order7vSpqmTcXrMeta?.path ?? "/en-xx/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___zh-hk",
    path: order7vSpqmTcXrMeta?.path ?? "/zh-hk/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___zh-tw",
    path: order7vSpqmTcXrMeta?.path ?? "/zh-tw/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-us",
    path: order7vSpqmTcXrMeta?.path ?? "/en-us/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-gb",
    path: order7vSpqmTcXrMeta?.path ?? "/en-gb/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-hk",
    path: order7vSpqmTcXrMeta?.path ?? "/en-hk/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-id",
    path: order7vSpqmTcXrMeta?.path ?? "/en-id/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-in",
    path: order7vSpqmTcXrMeta?.path ?? "/en-in/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___de-de",
    path: order7vSpqmTcXrMeta?.path ?? "/de-de/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-sg",
    path: order7vSpqmTcXrMeta?.path ?? "/en-sg/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-au",
    path: order7vSpqmTcXrMeta?.path ?? "/en-au/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-my",
    path: order7vSpqmTcXrMeta?.path ?? "/en-my/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-ph",
    path: order7vSpqmTcXrMeta?.path ?? "/en-ph/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-nz",
    path: order7vSpqmTcXrMeta?.path ?? "/en-nz/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___en-ca",
    path: order7vSpqmTcXrMeta?.path ?? "/en-ca/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___ja-jp",
    path: order7vSpqmTcXrMeta?.path ?? "/ja-jp/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: order7vSpqmTcXrMeta?.name ?? "member-order___ko-kr",
    path: order7vSpqmTcXrMeta?.path ?? "/ko-kr/member/order",
    meta: order7vSpqmTcXrMeta || {},
    alias: order7vSpqmTcXrMeta?.alias || [],
    redirect: order7vSpqmTcXrMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/order.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-xx___default",
    path: trRowDkskcR7FaDMeta?.path ?? "/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-xx",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-xx/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___zh-hk",
    path: trRowDkskcR7FaDMeta?.path ?? "/zh-hk/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___zh-tw",
    path: trRowDkskcR7FaDMeta?.path ?? "/zh-tw/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-us",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-us/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-gb",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-gb/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-hk",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-hk/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-id",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-id/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-in",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-in/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___de-de",
    path: trRowDkskcR7FaDMeta?.path ?? "/de-de/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-sg",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-sg/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-au",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-au/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-my",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-my/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-ph",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-ph/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-nz",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-nz/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___en-ca",
    path: trRowDkskcR7FaDMeta?.path ?? "/en-ca/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___ja-jp",
    path: trRowDkskcR7FaDMeta?.path ?? "/ja-jp/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: trRowDkskcR7FaDMeta?.name ?? "member-passenger-components-trRow___ko-kr",
    path: trRowDkskcR7FaDMeta?.path ?? "/ko-kr/member/passenger/components/trRow",
    meta: trRowDkskcR7FaDMeta || {},
    alias: trRowDkskcR7FaDMeta?.alias || [],
    redirect: trRowDkskcR7FaDMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/components/trRow.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-xx___default",
    path: editcYEH78TcjNMeta?.path ?? "/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-xx",
    path: editcYEH78TcjNMeta?.path ?? "/en-xx/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___zh-hk",
    path: editcYEH78TcjNMeta?.path ?? "/zh-hk/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___zh-tw",
    path: editcYEH78TcjNMeta?.path ?? "/zh-tw/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-us",
    path: editcYEH78TcjNMeta?.path ?? "/en-us/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-gb",
    path: editcYEH78TcjNMeta?.path ?? "/en-gb/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-hk",
    path: editcYEH78TcjNMeta?.path ?? "/en-hk/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-id",
    path: editcYEH78TcjNMeta?.path ?? "/en-id/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-in",
    path: editcYEH78TcjNMeta?.path ?? "/en-in/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___de-de",
    path: editcYEH78TcjNMeta?.path ?? "/de-de/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-sg",
    path: editcYEH78TcjNMeta?.path ?? "/en-sg/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-au",
    path: editcYEH78TcjNMeta?.path ?? "/en-au/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-my",
    path: editcYEH78TcjNMeta?.path ?? "/en-my/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-ph",
    path: editcYEH78TcjNMeta?.path ?? "/en-ph/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-nz",
    path: editcYEH78TcjNMeta?.path ?? "/en-nz/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___en-ca",
    path: editcYEH78TcjNMeta?.path ?? "/en-ca/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___ja-jp",
    path: editcYEH78TcjNMeta?.path ?? "/ja-jp/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: editcYEH78TcjNMeta?.name ?? "member-passenger-edit___ko-kr",
    path: editcYEH78TcjNMeta?.path ?? "/ko-kr/member/passenger/edit",
    meta: editcYEH78TcjNMeta || {},
    alias: editcYEH78TcjNMeta?.alias || [],
    redirect: editcYEH78TcjNMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/edit.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-xx___default",
    path: listFl4T873wT3Meta?.path ?? "/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-xx",
    path: listFl4T873wT3Meta?.path ?? "/en-xx/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___zh-hk",
    path: listFl4T873wT3Meta?.path ?? "/zh-hk/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___zh-tw",
    path: listFl4T873wT3Meta?.path ?? "/zh-tw/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-us",
    path: listFl4T873wT3Meta?.path ?? "/en-us/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-gb",
    path: listFl4T873wT3Meta?.path ?? "/en-gb/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-hk",
    path: listFl4T873wT3Meta?.path ?? "/en-hk/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-id",
    path: listFl4T873wT3Meta?.path ?? "/en-id/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-in",
    path: listFl4T873wT3Meta?.path ?? "/en-in/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___de-de",
    path: listFl4T873wT3Meta?.path ?? "/de-de/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-sg",
    path: listFl4T873wT3Meta?.path ?? "/en-sg/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-au",
    path: listFl4T873wT3Meta?.path ?? "/en-au/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-my",
    path: listFl4T873wT3Meta?.path ?? "/en-my/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-ph",
    path: listFl4T873wT3Meta?.path ?? "/en-ph/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-nz",
    path: listFl4T873wT3Meta?.path ?? "/en-nz/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___en-ca",
    path: listFl4T873wT3Meta?.path ?? "/en-ca/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___ja-jp",
    path: listFl4T873wT3Meta?.path ?? "/ja-jp/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: listFl4T873wT3Meta?.name ?? "member-passenger-list___ko-kr",
    path: listFl4T873wT3Meta?.path ?? "/ko-kr/member/passenger/list",
    meta: listFl4T873wT3Meta || {},
    alias: listFl4T873wT3Meta?.alias || [],
    redirect: listFl4T873wT3Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/passenger/list.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-xx___default",
    path: profilelkmZyvVPNUMeta?.path ?? "/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-xx",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-xx/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___zh-hk",
    path: profilelkmZyvVPNUMeta?.path ?? "/zh-hk/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___zh-tw",
    path: profilelkmZyvVPNUMeta?.path ?? "/zh-tw/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-us",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-us/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-gb",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-gb/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-hk",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-hk/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-id",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-id/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-in",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-in/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___de-de",
    path: profilelkmZyvVPNUMeta?.path ?? "/de-de/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-sg",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-sg/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-au",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-au/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-my",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-my/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-ph",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-ph/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-nz",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-nz/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___en-ca",
    path: profilelkmZyvVPNUMeta?.path ?? "/en-ca/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___ja-jp",
    path: profilelkmZyvVPNUMeta?.path ?? "/ja-jp/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: profilelkmZyvVPNUMeta?.name ?? "member-profile___ko-kr",
    path: profilelkmZyvVPNUMeta?.path ?? "/ko-kr/member/profile",
    meta: profilelkmZyvVPNUMeta || {},
    alias: profilelkmZyvVPNUMeta?.alias || [],
    redirect: profilelkmZyvVPNUMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/profile.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-xx___default",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-xx",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-xx/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___zh-hk",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/zh-hk/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___zh-tw",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/zh-tw/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-us",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-us/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-gb",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-gb/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-hk",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-hk/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-id",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-id/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-in",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-in/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___de-de",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/de-de/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-sg",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-sg/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-au",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-au/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-my",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-my/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-ph",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-ph/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-nz",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-nz/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___en-ca",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/en-ca/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___ja-jp",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/ja-jp/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerCardmXTmJBCl4jMeta?.name ?? "member-traveler-components-TravelerCard___ko-kr",
    path: TravelerCardmXTmJBCl4jMeta?.path ?? "/ko-kr/member/traveler/components/TravelerCard",
    meta: TravelerCardmXTmJBCl4jMeta || {},
    alias: TravelerCardmXTmJBCl4jMeta?.alias || [],
    redirect: TravelerCardmXTmJBCl4jMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerCard.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-xx___default",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-xx",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-xx/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___zh-hk",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/zh-hk/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___zh-tw",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/zh-tw/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-us",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-us/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-gb",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-gb/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-hk",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-hk/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-id",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-id/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-in",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-in/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___de-de",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/de-de/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-sg",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-sg/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-au",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-au/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-my",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-my/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-ph",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-ph/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-nz",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-nz/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___en-ca",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/en-ca/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___ja-jp",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/ja-jp/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: TravelerFormvU6HnvGr6IMeta?.name ?? "member-traveler-components-TravelerForm___ko-kr",
    path: TravelerFormvU6HnvGr6IMeta?.path ?? "/ko-kr/member/traveler/components/TravelerForm",
    meta: TravelerFormvU6HnvGr6IMeta || {},
    alias: TravelerFormvU6HnvGr6IMeta?.alias || [],
    redirect: TravelerFormvU6HnvGr6IMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/TravelerForm.vue").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-xx___default",
    path: typeTsbyAxcM13Meta?.path ?? "/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-xx",
    path: typeTsbyAxcM13Meta?.path ?? "/en-xx/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___zh-hk",
    path: typeTsbyAxcM13Meta?.path ?? "/zh-hk/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___zh-tw",
    path: typeTsbyAxcM13Meta?.path ?? "/zh-tw/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-us",
    path: typeTsbyAxcM13Meta?.path ?? "/en-us/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-gb",
    path: typeTsbyAxcM13Meta?.path ?? "/en-gb/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-hk",
    path: typeTsbyAxcM13Meta?.path ?? "/en-hk/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-id",
    path: typeTsbyAxcM13Meta?.path ?? "/en-id/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-in",
    path: typeTsbyAxcM13Meta?.path ?? "/en-in/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___de-de",
    path: typeTsbyAxcM13Meta?.path ?? "/de-de/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-sg",
    path: typeTsbyAxcM13Meta?.path ?? "/en-sg/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-au",
    path: typeTsbyAxcM13Meta?.path ?? "/en-au/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-my",
    path: typeTsbyAxcM13Meta?.path ?? "/en-my/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-ph",
    path: typeTsbyAxcM13Meta?.path ?? "/en-ph/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-nz",
    path: typeTsbyAxcM13Meta?.path ?? "/en-nz/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___en-ca",
    path: typeTsbyAxcM13Meta?.path ?? "/en-ca/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___ja-jp",
    path: typeTsbyAxcM13Meta?.path ?? "/ja-jp/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: typeTsbyAxcM13Meta?.name ?? "member-traveler-components-type___ko-kr",
    path: typeTsbyAxcM13Meta?.path ?? "/ko-kr/member/traveler/components/type",
    meta: typeTsbyAxcM13Meta || {},
    alias: typeTsbyAxcM13Meta?.alias || [],
    redirect: typeTsbyAxcM13Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/components/type.ts").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-xx___default",
    path: indexS0kzxrFah9Meta?.path ?? "/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-xx",
    path: indexS0kzxrFah9Meta?.path ?? "/en-xx/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___zh-hk",
    path: indexS0kzxrFah9Meta?.path ?? "/zh-hk/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___zh-tw",
    path: indexS0kzxrFah9Meta?.path ?? "/zh-tw/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-us",
    path: indexS0kzxrFah9Meta?.path ?? "/en-us/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-gb",
    path: indexS0kzxrFah9Meta?.path ?? "/en-gb/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-hk",
    path: indexS0kzxrFah9Meta?.path ?? "/en-hk/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-id",
    path: indexS0kzxrFah9Meta?.path ?? "/en-id/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-in",
    path: indexS0kzxrFah9Meta?.path ?? "/en-in/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___de-de",
    path: indexS0kzxrFah9Meta?.path ?? "/de-de/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-sg",
    path: indexS0kzxrFah9Meta?.path ?? "/en-sg/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-au",
    path: indexS0kzxrFah9Meta?.path ?? "/en-au/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-my",
    path: indexS0kzxrFah9Meta?.path ?? "/en-my/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-ph",
    path: indexS0kzxrFah9Meta?.path ?? "/en-ph/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-nz",
    path: indexS0kzxrFah9Meta?.path ?? "/en-nz/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___en-ca",
    path: indexS0kzxrFah9Meta?.path ?? "/en-ca/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___ja-jp",
    path: indexS0kzxrFah9Meta?.path ?? "/ja-jp/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: indexS0kzxrFah9Meta?.name ?? "member-traveler___ko-kr",
    path: indexS0kzxrFah9Meta?.path ?? "/ko-kr/member/traveler",
    meta: indexS0kzxrFah9Meta || {},
    alias: indexS0kzxrFah9Meta?.alias || [],
    redirect: indexS0kzxrFah9Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/member/traveler/index.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-xx___default",
    path: search8yWnc2zbDEMeta?.path ?? "/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-xx",
    path: search8yWnc2zbDEMeta?.path ?? "/en-xx/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___zh-hk",
    path: search8yWnc2zbDEMeta?.path ?? "/zh-hk/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___zh-tw",
    path: search8yWnc2zbDEMeta?.path ?? "/zh-tw/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-us",
    path: search8yWnc2zbDEMeta?.path ?? "/en-us/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-gb",
    path: search8yWnc2zbDEMeta?.path ?? "/en-gb/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-hk",
    path: search8yWnc2zbDEMeta?.path ?? "/en-hk/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-id",
    path: search8yWnc2zbDEMeta?.path ?? "/en-id/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-in",
    path: search8yWnc2zbDEMeta?.path ?? "/en-in/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___de-de",
    path: search8yWnc2zbDEMeta?.path ?? "/de-de/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-sg",
    path: search8yWnc2zbDEMeta?.path ?? "/en-sg/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-au",
    path: search8yWnc2zbDEMeta?.path ?? "/en-au/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-my",
    path: search8yWnc2zbDEMeta?.path ?? "/en-my/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-ph",
    path: search8yWnc2zbDEMeta?.path ?? "/en-ph/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-nz",
    path: search8yWnc2zbDEMeta?.path ?? "/en-nz/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___en-ca",
    path: search8yWnc2zbDEMeta?.path ?? "/en-ca/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___ja-jp",
    path: search8yWnc2zbDEMeta?.path ?? "/ja-jp/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: search8yWnc2zbDEMeta?.name ?? "order-search___ko-kr",
    path: search8yWnc2zbDEMeta?.path ?? "/ko-kr/order/search",
    meta: search8yWnc2zbDEMeta || {},
    alias: search8yWnc2zbDEMeta?.alias || [],
    redirect: search8yWnc2zbDEMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/order/search.vue").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-xx___default",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-xx",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-xx/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___zh-hk",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/zh-hk/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___zh-tw",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/zh-tw/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-us",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-us/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-gb",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-gb/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-hk",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-hk/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-id",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-id/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-in",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-in/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___de-de",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/de-de/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-sg",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-sg/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-au",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-au/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-my",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-my/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-ph",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-ph/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-nz",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-nz/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___en-ca",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/en-ca/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___ja-jp",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/ja-jp/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: defaultAreaCodeCMtFnmHXh4Meta?.name ?? "passport-defaultAreaCode___ko-kr",
    path: defaultAreaCodeCMtFnmHXh4Meta?.path ?? "/ko-kr/passport/defaultAreaCode",
    meta: defaultAreaCodeCMtFnmHXh4Meta || {},
    alias: defaultAreaCodeCMtFnmHXh4Meta?.alias || [],
    redirect: defaultAreaCodeCMtFnmHXh4Meta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/defaultAreaCode.ts").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-xx___default",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-xx",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-xx/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___zh-hk",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/zh-hk/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___zh-tw",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/zh-tw/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-us",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-us/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-gb",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-gb/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-hk",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-hk/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-id",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-id/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-in",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-in/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___de-de",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/de-de/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-sg",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-sg/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-au",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-au/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-my",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-my/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-ph",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-ph/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-nz",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-nz/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___en-ca",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/en-ca/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___ja-jp",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/ja-jp/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: forgotpassworddIeZiqa76vMeta?.name ?? "passport-forgotpassword___ko-kr",
    path: forgotpassworddIeZiqa76vMeta?.path ?? "/ko-kr/passport/forgotpassword",
    meta: forgotpassworddIeZiqa76vMeta || {},
    alias: forgotpassworddIeZiqa76vMeta?.alias || [],
    redirect: forgotpassworddIeZiqa76vMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/forgotpassword.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-xx___default",
    path: signinlSMegm6ThTMeta?.path ?? "/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-xx",
    path: signinlSMegm6ThTMeta?.path ?? "/en-xx/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___zh-hk",
    path: signinlSMegm6ThTMeta?.path ?? "/zh-hk/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___zh-tw",
    path: signinlSMegm6ThTMeta?.path ?? "/zh-tw/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-us",
    path: signinlSMegm6ThTMeta?.path ?? "/en-us/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-gb",
    path: signinlSMegm6ThTMeta?.path ?? "/en-gb/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-hk",
    path: signinlSMegm6ThTMeta?.path ?? "/en-hk/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-id",
    path: signinlSMegm6ThTMeta?.path ?? "/en-id/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-in",
    path: signinlSMegm6ThTMeta?.path ?? "/en-in/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___de-de",
    path: signinlSMegm6ThTMeta?.path ?? "/de-de/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-sg",
    path: signinlSMegm6ThTMeta?.path ?? "/en-sg/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-au",
    path: signinlSMegm6ThTMeta?.path ?? "/en-au/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-my",
    path: signinlSMegm6ThTMeta?.path ?? "/en-my/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-ph",
    path: signinlSMegm6ThTMeta?.path ?? "/en-ph/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-nz",
    path: signinlSMegm6ThTMeta?.path ?? "/en-nz/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___en-ca",
    path: signinlSMegm6ThTMeta?.path ?? "/en-ca/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___ja-jp",
    path: signinlSMegm6ThTMeta?.path ?? "/ja-jp/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signinlSMegm6ThTMeta?.name ?? "passport-signin___ko-kr",
    path: signinlSMegm6ThTMeta?.path ?? "/ko-kr/passport/signin",
    meta: signinlSMegm6ThTMeta || {},
    alias: signinlSMegm6ThTMeta?.alias || [],
    redirect: signinlSMegm6ThTMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signin.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-xx___default",
    path: signupoefkNKDjZjMeta?.path ?? "/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-xx",
    path: signupoefkNKDjZjMeta?.path ?? "/en-xx/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___zh-hk",
    path: signupoefkNKDjZjMeta?.path ?? "/zh-hk/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___zh-tw",
    path: signupoefkNKDjZjMeta?.path ?? "/zh-tw/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-us",
    path: signupoefkNKDjZjMeta?.path ?? "/en-us/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-gb",
    path: signupoefkNKDjZjMeta?.path ?? "/en-gb/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-hk",
    path: signupoefkNKDjZjMeta?.path ?? "/en-hk/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-id",
    path: signupoefkNKDjZjMeta?.path ?? "/en-id/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-in",
    path: signupoefkNKDjZjMeta?.path ?? "/en-in/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___de-de",
    path: signupoefkNKDjZjMeta?.path ?? "/de-de/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-sg",
    path: signupoefkNKDjZjMeta?.path ?? "/en-sg/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-au",
    path: signupoefkNKDjZjMeta?.path ?? "/en-au/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-my",
    path: signupoefkNKDjZjMeta?.path ?? "/en-my/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-ph",
    path: signupoefkNKDjZjMeta?.path ?? "/en-ph/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-nz",
    path: signupoefkNKDjZjMeta?.path ?? "/en-nz/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___en-ca",
    path: signupoefkNKDjZjMeta?.path ?? "/en-ca/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___ja-jp",
    path: signupoefkNKDjZjMeta?.path ?? "/ja-jp/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: signupoefkNKDjZjMeta?.name ?? "passport-signup___ko-kr",
    path: signupoefkNKDjZjMeta?.path ?? "/ko-kr/passport/signup",
    meta: signupoefkNKDjZjMeta || {},
    alias: signupoefkNKDjZjMeta?.alias || [],
    redirect: signupoefkNKDjZjMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/signup.vue").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-xx___default",
    path: trackerCxR2RaIYMfMeta?.path ?? "/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-xx",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-xx/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___zh-hk",
    path: trackerCxR2RaIYMfMeta?.path ?? "/zh-hk/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___zh-tw",
    path: trackerCxR2RaIYMfMeta?.path ?? "/zh-tw/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-us",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-us/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-gb",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-gb/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-hk",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-hk/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-id",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-id/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-in",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-in/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___de-de",
    path: trackerCxR2RaIYMfMeta?.path ?? "/de-de/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-sg",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-sg/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-au",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-au/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-my",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-my/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-ph",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-ph/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-nz",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-nz/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___en-ca",
    path: trackerCxR2RaIYMfMeta?.path ?? "/en-ca/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___ja-jp",
    path: trackerCxR2RaIYMfMeta?.path ?? "/ja-jp/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: trackerCxR2RaIYMfMeta?.name ?? "passport-tracker___ko-kr",
    path: trackerCxR2RaIYMfMeta?.path ?? "/ko-kr/passport/tracker",
    meta: trackerCxR2RaIYMfMeta || {},
    alias: trackerCxR2RaIYMfMeta?.alias || [],
    redirect: trackerCxR2RaIYMfMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/passport/tracker.ts").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-xx___default",
    path: index18RMcZIEyOMeta?.path ?? "/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-xx",
    path: index18RMcZIEyOMeta?.path ?? "/en-xx/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___zh-hk",
    path: index18RMcZIEyOMeta?.path ?? "/zh-hk/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___zh-tw",
    path: index18RMcZIEyOMeta?.path ?? "/zh-tw/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-us",
    path: index18RMcZIEyOMeta?.path ?? "/en-us/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-gb",
    path: index18RMcZIEyOMeta?.path ?? "/en-gb/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-hk",
    path: index18RMcZIEyOMeta?.path ?? "/en-hk/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-id",
    path: index18RMcZIEyOMeta?.path ?? "/en-id/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-in",
    path: index18RMcZIEyOMeta?.path ?? "/en-in/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___de-de",
    path: index18RMcZIEyOMeta?.path ?? "/de-de/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-sg",
    path: index18RMcZIEyOMeta?.path ?? "/en-sg/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-au",
    path: index18RMcZIEyOMeta?.path ?? "/en-au/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-my",
    path: index18RMcZIEyOMeta?.path ?? "/en-my/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-ph",
    path: index18RMcZIEyOMeta?.path ?? "/en-ph/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-nz",
    path: index18RMcZIEyOMeta?.path ?? "/en-nz/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___en-ca",
    path: index18RMcZIEyOMeta?.path ?? "/en-ca/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___ja-jp",
    path: index18RMcZIEyOMeta?.path ?? "/ja-jp/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: index18RMcZIEyOMeta?.name ?? "pc-keepalive___ko-kr",
    path: index18RMcZIEyOMeta?.path ?? "/ko-kr/pc/keepalive",
    meta: index18RMcZIEyOMeta || {},
    alias: index18RMcZIEyOMeta?.alias || [],
    redirect: index18RMcZIEyOMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pc/keepalive/index.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-xx___default",
    path: piniapfktKYURJuMeta?.path ?? "/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-xx",
    path: piniapfktKYURJuMeta?.path ?? "/en-xx/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___zh-hk",
    path: piniapfktKYURJuMeta?.path ?? "/zh-hk/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___zh-tw",
    path: piniapfktKYURJuMeta?.path ?? "/zh-tw/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-us",
    path: piniapfktKYURJuMeta?.path ?? "/en-us/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-gb",
    path: piniapfktKYURJuMeta?.path ?? "/en-gb/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-hk",
    path: piniapfktKYURJuMeta?.path ?? "/en-hk/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-id",
    path: piniapfktKYURJuMeta?.path ?? "/en-id/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-in",
    path: piniapfktKYURJuMeta?.path ?? "/en-in/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___de-de",
    path: piniapfktKYURJuMeta?.path ?? "/de-de/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-sg",
    path: piniapfktKYURJuMeta?.path ?? "/en-sg/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-au",
    path: piniapfktKYURJuMeta?.path ?? "/en-au/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-my",
    path: piniapfktKYURJuMeta?.path ?? "/en-my/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-ph",
    path: piniapfktKYURJuMeta?.path ?? "/en-ph/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-nz",
    path: piniapfktKYURJuMeta?.path ?? "/en-nz/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___en-ca",
    path: piniapfktKYURJuMeta?.path ?? "/en-ca/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___ja-jp",
    path: piniapfktKYURJuMeta?.path ?? "/ja-jp/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: piniapfktKYURJuMeta?.name ?? "pinia___ko-kr",
    path: piniapfktKYURJuMeta?.path ?? "/ko-kr/pinia",
    meta: piniapfktKYURJuMeta || {},
    alias: piniapfktKYURJuMeta?.alias || [],
    redirect: piniapfktKYURJuMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/pinia.vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-xx___default",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-xx",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-xx/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___zh-hk",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/zh-hk/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___zh-tw",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/zh-tw/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-us",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-us/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-gb",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-gb/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-hk",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-hk/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-id",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-id/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-in",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-in/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___de-de",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/de-de/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-sg",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-sg/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-au",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-au/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-my",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-my/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-ph",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-ph/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-nz",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-nz/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___en-ca",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/en-ca/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___ja-jp",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/ja-jp/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: _91nameId_93RiJ3MUtJLBMeta?.name ?? "travelguide-nameId___ko-kr",
    path: _91nameId_93RiJ3MUtJLBMeta?.path ?? "/ko-kr/travelguide/:nameId()",
    meta: _91nameId_93RiJ3MUtJLBMeta || {},
    alias: _91nameId_93RiJ3MUtJLBMeta?.alias || [],
    redirect: _91nameId_93RiJ3MUtJLBMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/travelguide/[nameId].vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-xx___default",
    path: indextxzPft6s6CMeta?.path ?? "/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-xx",
    path: indextxzPft6s6CMeta?.path ?? "/en-xx/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___zh-hk",
    path: indextxzPft6s6CMeta?.path ?? "/zh-hk/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___zh-tw",
    path: indextxzPft6s6CMeta?.path ?? "/zh-tw/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-us",
    path: indextxzPft6s6CMeta?.path ?? "/en-us/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-gb",
    path: indextxzPft6s6CMeta?.path ?? "/en-gb/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-hk",
    path: indextxzPft6s6CMeta?.path ?? "/en-hk/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-id",
    path: indextxzPft6s6CMeta?.path ?? "/en-id/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-in",
    path: indextxzPft6s6CMeta?.path ?? "/en-in/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___de-de",
    path: indextxzPft6s6CMeta?.path ?? "/de-de/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-sg",
    path: indextxzPft6s6CMeta?.path ?? "/en-sg/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-au",
    path: indextxzPft6s6CMeta?.path ?? "/en-au/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-my",
    path: indextxzPft6s6CMeta?.path ?? "/en-my/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-ph",
    path: indextxzPft6s6CMeta?.path ?? "/en-ph/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-nz",
    path: indextxzPft6s6CMeta?.path ?? "/en-nz/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___en-ca",
    path: indextxzPft6s6CMeta?.path ?? "/en-ca/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___ja-jp",
    path: indextxzPft6s6CMeta?.path ?? "/ja-jp/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: indextxzPft6s6CMeta?.name ?? "unsubscribe___ko-kr",
    path: indextxzPft6s6CMeta?.path ?? "/ko-kr/unsubscribe",
    meta: indextxzPft6s6CMeta || {},
    alias: indextxzPft6s6CMeta?.alias || [],
    redirect: indextxzPft6s6CMeta?.redirect,
    component: () => import("/home/jenkins/workspace/docker_hopegoo.web.pc_product/src/pages/unsubscribe/index.vue").then(m => m.default || m)
  }
]